import React from 'react';
import { Header } from '../components/landing/Header';
import { Hero } from '../components/landing/Hero';
import { CreativeCarousel } from '../components/landing/CreativeCarousel';
import { PromoCampaign } from '../components/landing/PromoCampaign';
import { ProblemSolution } from '../components/landing/ProblemSolution';
import { HowItWorks } from '../components/landing/HowItWorks';
import { Testimonials } from '../components/landing/Testimonials';
import { ExpertValidation } from '../components/landing/ExpertValidation';
import { OfferSection } from '../components/landing/OfferSection';
import { Guarantee } from '../components/landing/Guarantee';
import { FAQ } from '../components/landing/FAQ';
import { FinalCTA } from '../components/landing/FinalCTA';
import { Footer } from '../components/landing/Footer';
import { MobilePromoButton } from '../components/landing/MobilePromoButton';
export function FinancialPackLanding() {
  return <div className="min-h-screen font-sans text-gray-900 bg-white selection:bg-[#d4a574] selection:text-[#1e3a5f]" data-id="element-733">
      <Header data-id="element-734" />
      <main data-id="element-735">
        <Hero data-id="element-736" />
        <CreativeCarousel data-id="element-737" />
        <PromoCampaign data-id="element-738" />
        <HowItWorks data-id="element-739" />
        <Testimonials data-id="element-740" />
        <ExpertValidation data-id="element-741" />
        <OfferSection data-id="element-742" />
        <Guarantee data-id="element-743" />
        <FAQ data-id="element-744" />
        <FinalCTA data-id="element-745" />
      </main>
      <Footer data-id="element-746" />
      <MobilePromoButton data-id="element-747" />
    </div>;
}